__turbopack_context__.v({
  "asLink": "Button-module__NzAzKq__asLink",
  "bare": "Button-module__NzAzKq__bare",
  "button": "Button-module__NzAzKq__button",
  "content": "Button-module__NzAzKq__content",
  "extraSmall": "Button-module__NzAzKq__extraSmall",
  "fullWidth": "Button-module__NzAzKq__fullWidth",
  "hidden": "Button-module__NzAzKq__hidden",
  "icon": "Button-module__NzAzKq__icon",
  "large": "Button-module__NzAzKq__large",
  "minimal": "Button-module__NzAzKq__minimal",
  "minimalPadding": "Button-module__NzAzKq__minimalPadding",
  "neutral": "Button-module__NzAzKq__neutral",
  "noWrap": "Button-module__NzAzKq__noWrap",
  "pill": "Button-module__NzAzKq__pill",
  "pillLegacy": "Button-module__NzAzKq__pillLegacy",
  "pillShape": "Button-module__NzAzKq__pillShape",
  "primary": "Button-module__NzAzKq__primary",
  "responsive": "Button-module__NzAzKq__responsive" + " " + "Button-module__NzAzKq__fullWidth",
  "secondary": "Button-module__NzAzKq__secondary",
  "small": "Button-module__NzAzKq__small",
  "spinner": "Button-module__NzAzKq__spinner",
  "tertiary": "Button-module__NzAzKq__tertiary",
  "transparent": "Button-module__NzAzKq__transparent",
  "underlined": "Button-module__NzAzKq__underlined",
});
